export enum EmployeeCalendarRegisterStatus {
  COMPLETED = 'completed',
  UPCOMING = 'upcoming',
  NOT_SCHEDULED = 'not_scheduled',
}
